import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { base_url, config } from '../utils/axiosConfig'; // Import from your config file

const AUTO_SLIDE_INTERVAL = 2500;

const RecentlyAddProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [productsPerPage, setProductsPerPage] = useState(4);

  // Dynamically set products per page based on screen size
  useEffect(() => {
    const updateProductsPerPage = () => {
      if (window.innerWidth <= 768) {
        setProductsPerPage(2); // 2 cards on mobile
      } else {
        setProductsPerPage(4); // 4 cards on larger screens
      }
    };

    updateProductsPerPage();
    window.addEventListener('resize', updateProductsPerPage);
    return () => window.removeEventListener('resize', updateProductsPerPage);
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${base_url}Products`, config);
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.products || [];
        setProducts(data.slice(0, 12));
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const maxIndex = Math.ceil(products.length / productsPerPage) - 1;

  const handlePrev = () => {
    setCurrentIndex(prev => (prev === 0 ? maxIndex : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex(prev => (prev === maxIndex ? 0 : prev + 1));
  };

  useEffect(() => {
    const interval = setInterval(handleNext, AUTO_SLIDE_INTERVAL);
    return () => clearInterval(interval);
  }, [currentIndex, maxIndex]);

  const start = currentIndex * productsPerPage;
  const end = start + productsPerPage;
  const visibleProducts = products.slice(start, end);

  return (
    <section className="recently-added">
      <div className="container position-relative">
        <h3 className="section-heading mb-5">Recently Added Products</h3>
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : products.length > 0 ? (
          <div className="slider-wrapper">
            <button className="slider-arrow left" onClick={handlePrev}>
              <IoIosArrowBack size={20} />
            </button>
            <div className="slider-row">
              <div className="slider-track">
                {visibleProducts.map((product, index) => {
                  const imageUrl = product.images?.[0]?.url
                    ? `${base_url}${product.images[0].url}`
                    : 'https://via.placeholder.com/200x200?text=No+Image';

                  const hasOffer = product.offerPrice && product.offerPrice > 0;
                  const displayPrice = hasOffer ? product.offerPrice : product.CurrentPrice;

                  return (
                    <div className="slider-card" key={product._id || index}>
                      <div className="custom-card">
                        <div className="image-wrapper1">
                          <img src={imageUrl} alt={product?.title || 'Product'} />
                        </div>
                        <div className="card-content">
                          <h6 className="name">{product?.title || 'No Name'}</h6>
                          <div className="price-box">
                            <span className="price">₹{displayPrice}</span>
                            {hasOffer && (
                              <span className="old-price">₹{product.CurrentPrice}</span>
                            )}
                          </div>
                          {product?.remarks && (
                            <p className="remarks">{product.remarks}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <button className="slider-arrow right" onClick={handleNext}>
              <IoIosArrowForward size={20} />
            </button>
          </div>
        ) : (
          <p className="no-products text-center">No products available.</p>
        )}
      </div>
    </section>
  );
};

export default RecentlyAddProducts;